// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"ec54af53","228":"085520cc","401":"18af1b95","657":"060abac9","730":"9d65943b","759":"6b09d7ab","859":"bc4546e6"}[chunkId] + ".chunk.js";
};